module.exports = __webpack_public_path__ + "c9e1642ea518b0b066e07f344979600d.fbx";